import { registerIllustrationImages } from '@greensm/ui';
import rideCar from '@/assets/brand/home-ride-car.png';
import foodCombo from '@/assets/brand/home-food-combo.png';
import bike3D from '@/assets/brand/service-bike-3d.png';
import map3D from '@/assets/brand/service-map-3d.png';
import delivery3D from '@/assets/brand/service-delivery-3d.png';
import diamond3D from '@/assets/brand/service-diamond-3d.png';
import showroom3D from '@/assets/brand/service-showroom-3d.png';
import airplane3D from '@/assets/brand/service-airplane-3d.png';
import giftcard3D from '@/assets/brand/service-giftcard-3d.png';
import key3D from '@/assets/brand/service-key-3d.png';
import limo from '@/assets/brand/icon-limo.png';
import paycard from '@/assets/brand/icon-paycard.png';
import voucher from '@/assets/brand/icon-voucher.png';

/**
 * Hình minh hoạ CHÍNH THỨC 3D của Green SM (trích xuất chuẩn xác từ ảnh mẫu thiết kế S04).
 * Đồng bộ toàn bộ các thẻ chính Đặt xe, Đặt đồ ăn và cụm Dịch vụ khác 1:1 với bản mẫu.
 */
registerIllustrationImages({
  bike: bike3D,
  car: rideCar,
  mini: rideCar,
  package: delivery3D,
  food: foodCombo,
  card: giftcard3D,
  diamond: diamond3D,
  plane: airplane3D,
  premium: showroom3D,
  map: map3D,
  key: key3D,
  limo,
  paycard,
  voucher,
});
